import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import {MatCardModule} from '@angular/material/card';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { AppDetailsComponent } from './app-details/app-details.component';
import { AppPrivacyPolicyComponent } from './app-privacy-policy/app-privacy-policy.component';

@NgModule({
  declarations: [
    AppComponent,
    AppDetailsComponent,
    AppPrivacyPolicyComponent
  ],
  imports: [
    BrowserModule,
    RouterModule.forRoot([
      { path: '', redirectTo: 'app-details', pathMatch: 'full' },
      {path: 'app-privacy-policy', component: AppPrivacyPolicyComponent},
      {path: 'app-details', component: AppDetailsComponent},
    ]),
    AppRoutingModule,
    NoopAnimationsModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
